import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Grid, Typography } from '@material-ui/core';

import { SegmentPicker } from 'components/Pickers';
import { ContentEmailValues } from 'features/admin/types';
import { UserSegmentFragment } from 'api';

import Tip from 'components/Tip';

const Recipients: FC = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<ContentEmailValues>();
  const { all_users, segment_ids } = values;

  function handleChange(segmentIds: Array<UserSegmentFragment['id']>, entireCompany: boolean) {
    setFieldValue('segment_ids', segmentIds);
    setFieldValue('all_users', entireCompany);
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Typography variant="subtitle2">{t('common:recipient_plural')}</Typography>
      </Grid>
      <Grid item xs={9}>
        <SegmentPicker
          isCompanySelected={all_users}
          selectedSegmentsIds={segment_ids}
          onSegmentChange={handleChange}
        />
        <Tip i18nKey="contentEmails:recipientsTip" />
      </Grid>
    </Grid>
  );
};

export default Recipients;
